(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-gift-card"]) return;
  try {
    
function initialiseFurForeverGiftCards(root) {
  root.querySelectorAll('.ff-gift__form').forEach(form => {
    const toggle = form.querySelector('[data-recipient-toggle]');
    const fields = form.querySelector('[data-recipient-fields]');
    if (!toggle || !fields || toggle.dataset.ready) return;
    toggle.dataset.ready = 'true';
    toggle.disabled = false;
    const update = () => {
      fields.hidden = !toggle.checked;
      fields.disabled = !toggle.checked;
      toggle.setAttribute('aria-expanded', String(toggle.checked));
    };
    toggle.addEventListener('change', update);
    update();
  });
}
initialiseFurForeverGiftCards(document);
document.addEventListener('shopify:section:load', event => initialiseFurForeverGiftCards(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-reviews-experience"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = (root) => {
    if (!root || root.dataset.ffReady) return;
    root.dataset.ffReady = 'true';
    const feed = root.querySelector('[data-ff-feed]');
    const filters = root.querySelector('[data-ff-filters]');
    const status = root.querySelector('[data-ff-status]');
    const more = root.querySelector('[data-ff-more]');
    const empty = root.querySelector('[data-ff-empty]');
    const chooser = root.querySelector('#ff-review-your-piece');
    const select = root.querySelector('[data-ff-product-select]');
    const go = root.querySelector('[data-ff-product-go]');
    let topic = 'all';
    let limit = 4;
    let timer;
    const patterns = {
      care: /care|respect|sensitiv|trust|safe|return|leftover|unused|precious|post|send|sent/i,
      quality: /quality|craft|beautiful|stunning|perfect|detail|well made|well-made|flawless|finish/i,
      sizing: /\bfit\b|\bfits\b|fitting|size|sizing|sizer|comfort|width/i,
      ordering: /communicat|service|helpful|helped|question|order|process|update|deliver|arriv|packag/i
    };
    const render = () => {
      const cards = [...feed.querySelectorAll('.vtl-pr-ri__wrapper')];
      if (!cards.length) return;
      filters.hidden = false;
      status.hidden = false;
      const matching = cards.filter(card => topic === 'all' || patterns[topic].test(card.querySelector('.vtl-pr-ri__message')?.textContent || ''));
      const visible = new Set(matching.slice(0, limit));
      cards.forEach(card => card.classList.toggle('ff-review-hidden', !visible.has(card)));
      more.hidden = matching.length <= limit;
      empty.hidden = matching.length > 0;
      status.textContent = status.dataset.countText.replace('[shown]', Math.min(limit, matching.length)).replace('[total]', matching.length);
      feed.querySelectorAll('.vtl-pr-main-widget__show-more-button').forEach(button => button.classList.toggle('ff-review-hidden', matching.length > limit));
      root.querySelectorAll('[data-ff-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ffFilter === topic)));
    };
    const chooseTopic = (value) => {
      topic = Object.hasOwn(patterns, value) ? value : 'all';
      limit = 4;
      render();
    };
    root.querySelectorAll('[data-ff-filter]').forEach(button => button.addEventListener('click', () => chooseTopic(button.dataset.ffFilter)));
    root.querySelectorAll('[data-ff-topic-link]').forEach(link => link.addEventListener('click', () => chooseTopic(link.dataset.ffTopicLink)));
    more.addEventListener('click', () => {
      const hadFocus = document.activeElement === more;
      const previouslyVisible = new Set([...feed.querySelectorAll('.vtl-pr-ri__wrapper')].filter(card => !card.classList.contains('ff-review-hidden')));
      limit += 4;
      render();
      if (hadFocus && more.hidden) {
        const firstRevealed = [...feed.querySelectorAll('.vtl-pr-ri__wrapper')].find(card => !card.classList.contains('ff-review-hidden') && !previouslyVisible.has(card));
        const focusTarget = firstRevealed || root.querySelector('#ff-stories-heading');
        if (focusTarget) {
          if (!focusTarget.hasAttribute('tabindex')) focusTarget.setAttribute('tabindex', '-1');
          focusTarget.classList.add('ff-review-focus-target');
          focusTarget.focus();
        }
      }
    });
    root.querySelectorAll('[data-ff-browse-reviews]').forEach(link => link.addEventListener('click', () => {
      chooser.open = true;
      requestAnimationFrame(() => select.focus({preventScroll:true}));
    }));
    select.addEventListener('change', () => {
      const value = select.value;
      go.hidden = !value;
      if (value) go.href = value;
      else go.removeAttribute('href');
    });
    if (location.hash === '#ff-review-your-piece') chooser.open = true;
    const observer = new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(render, 40); });
    observer.observe(feed, {childList:true, subtree:true});
    render();
    setTimeout(() => { if (!feed.querySelector('.vtl-pr-ri__wrapper')) status.hidden = true; }, 15000);
    root.addEventListener('shopify:section:unload', () => { observer.disconnect(); clearTimeout(timer); }, {once:true});
  };
  document.querySelectorAll('[data-ff-reviews]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => initialise(event.target.querySelector('[data-ff-reviews]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-welcome-popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ff-welcome-popup')) {
  customElements.define('ff-welcome-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.teaser = this.querySelector('[data-welcome-open]');
      this.form = this.querySelector('form');
      this.state = this.querySelector('[data-welcome-state]');
      this.storageKey = 'ff_welcome_v1';
      this.abort = new AbortController();
      const options = { signal:this.abort.signal };
      const params = new URLSearchParams(location.search);
      this.preview = this.dataset.designMode === 'true' || (params.has('preview_theme_id') && params.get('ff_popup_preview') === '1');
      this.eligible = this.dataset.eligible === 'true';
      const record = this.read('localStorage', this.storageKey);
      const ownResponse = location.hash === '#' + this.form.id;
      const error = this.state.dataset.error === 'true' && ownResponse;
      const success = this.state.dataset.success === 'true' && ownResponse && !error;
      this.subscribed = !error && Boolean(record && record.subscribed);
      if (success) {
        this.subscribed = true;
        this.write('localStorage', this.storageKey, { subscribed:true });
      }
      if (success || error) {
        const cleanUrl = new URL(location.href);
        cleanUrl.searchParams.delete('ff_welcome');
        cleanUrl.searchParams.delete('customer_posted');
        if (cleanUrl.hash === '#' + this.form.id) cleanUrl.hash = '';
        history.replaceState(history.state, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
      }
      if (this.subscribed) this.showSuccess();
      this.teaser.addEventListener('click', () => this.open(), options);
      this.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', () => this.close(), options));
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.close();
      }, options);
      this.querySelector('[data-welcome-copy]').addEventListener('click', async event => {
        const button = event.currentTarget;
        try {
          await navigator.clipboard.writeText(this.dataset.code);
          this.querySelector('[data-copy-status]').textContent = button.dataset.copied;
        } catch {
          this.querySelector('[data-copy-status]').textContent = button.dataset.copyFailed;
        }
      }, options);
      document.addEventListener('shopify:section:select', event => {
        if (event.target.contains(this)) this.open();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (this.waiting && !document.hidden) this.tryOpen();
      }, options);
      const shopLink = this.querySelector('[data-welcome-shop]');
      if (params.has('preview_theme_id')) {
        const shopUrl = new URL(shopLink.href);
        const redirect = new URL(shopUrl.searchParams.get('redirect') || '/', location.origin);
        redirect.searchParams.set('preview_theme_id', params.get('preview_theme_id'));
        shopUrl.searchParams.set('redirect', redirect.pathname + redirect.search);
        shopLink.href = shopUrl.href;
      }
      if (success || error || this.preview) {
        this.open();
      } else if (this.eligible) {
        this.teaser.hidden = false;
        if (!this.subscribed && !(record && record.dismissedUntil > Date.now())) {
          this.timer = setTimeout(() => this.tryOpen(), Number(this.dataset.delay) * 1000);
        }
      }
    }
    read(storage, key) { try { return JSON.parse(window[storage].getItem(key) || 'null'); } catch { return null; } }
    write(storage, key, value) { try { window[storage].setItem(key, JSON.stringify(value)); } catch {} }
    showSuccess() {
      this.querySelector('[data-welcome-signup]').hidden = true;
      this.querySelector('[data-welcome-success]').hidden = false;
      const title = this.querySelector('[data-success-title]');
      title.id = this.dialog.id + '-success';
      this.dialog.setAttribute('aria-labelledby', title.id);
      this.teaser.textContent = this.querySelector('[data-teaser-success]').textContent;
    }
    tryOpen() {
      if (!this.isConnected || this.dialog.open || this.subscribed) return;
      const otherDialog = [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], #shopify-pc__banner')].some(el => el !== this.dialog && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden' && getComputedStyle(el).opacity !== '0');
      const inputFocused = document.activeElement && /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName);
      if (document.hidden || otherDialog || inputFocused) {
        this.waiting = true;
        this.timer = setTimeout(() => this.tryOpen(), 5000);
        return;
      }
      this.waiting = false;
      this.open();
    }
    open() {
      clearTimeout(this.timer);
      this.waiting = false;
      if (this.dialog.open) return;
      this.previousFocus = document.activeElement;
      this.teaser.hidden = true;
      this.dialog.showModal();
      this.querySelector(this.subscribed ? '[data-success-title]' : '.ff-welcome__title').focus({preventScroll:true});
    }
    close() {
      clearTimeout(this.timer);
      this.waiting = false;
      this.dialog.close();
      if (!this.preview && !this.subscribed) this.write('localStorage', this.storageKey, {dismissedUntil:Date.now() + Number(this.dataset.dismissDays) * 86400000});
      this.teaser.hidden = !this.eligible && !this.preview;
      if (this.previousFocus && this.previousFocus !== document.body && this.previousFocus.isConnected) this.previousFocus.focus({preventScroll:true});
      else if (!this.teaser.hidden) this.teaser.focus({preventScroll:true});
    }
    disconnectedCallback() { clearTimeout(this.timer); if (this.abort) this.abort.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const sectionEl = document.querySelector('.product-recommendations');

  function loadProductRecommendations() {
    const { limit, url } = sectionEl.dataset;

    fetch(sectionEl.dataset.url)
      .then((response) => response.text())
      .then((responseText) => {
        const div = document.createElement('div');
        div.innerHTML = responseText;

        const rec = div.querySelector('.product-recommendations');
        if (rec && rec.innerHTML.trim().length) {
          document.querySelector('.product-recommendations').innerHTML = rec.innerHTML;
        }

        theme.initProductTitleAlignmentWatcher(sectionEl, '.productRecommendations');
      })
      .catch((error) => {
        console.log(error);
      });
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (sectionEl.dataset.sectionId === e.detail.sectionId) {
      loadProductRecommendations();
    }
  });

  document.addEventListener('DOMContentLoaded', loadProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
